import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from "../../../lib/utils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../MenuItem.styles";
/**
 *
 * `MenuItem` - это вложенный компонент, задающий базовые стили для элемента меню и позволяющий навигироваться по элементам меню с помощью клавиатуры.
 *
 * Сущности в которых может быть использован `MenuItem`: [`DropdownMenu`](#/Components/DropdownMenu), [`Kebab`](#/Components/Kebab), [`TooltipMenu`](#/Components/TooltipMenu) и [`Select`](#/Components/Select).
 */

export var MenuItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MenuItem, _React$Component);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.theme = void 0;
    _this.mouseEntered = false;

    _this.renderMain = function (props) {
      var _cx, _cx2;

      var link = props.link,
          comment = props.comment,
          icon = props.icon,
          loose = props.loose,
          state = props.state,
          _enableIconPadding = props._enableIconPadding,
          component = props.component,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          rest = _objectWithoutPropertiesLoose(props, ["link", "comment", "icon", "loose", "state", "_enableIconPadding", "component", "onMouseEnter", "onMouseLeave"]);

      var hover = state === 'hover' && !_this.props.disabled;
      var iconElement = null;

      if (icon) {
        iconElement = /*#__PURE__*/React.createElement("div", {
          className: styles.icon(_this.theme)
        }, icon);
      }

      var className = cx((_cx = {}, _cx[styles.root(_this.theme)] = true, _cx[styles.loose()] = !!loose, _cx[styles.hover(_this.theme)] = hover, _cx[styles.selected(_this.theme)] = state === 'selected', _cx[styles.link(_this.theme)] = !!link, _cx[styles.withIcon(_this.theme)] = Boolean(iconElement) || !!_enableIconPadding, _cx[styles.disabled(_this.theme)] = !!_this.props.disabled, _cx));
      var children = _this.props.children;
      var content = children;

      if (isFunction(children)) {
        content = children(_this.props.state);
      }

      var Component = _this.getComponent();

      return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
        state: state,
        onMouseOver: _this.handleMouseEnterFix,
        onMouseLeave: _this.handleMouseLeave,
        className: className,
        tabIndex: -1
      }), iconElement, content, _this.props.comment && /*#__PURE__*/React.createElement("div", {
        "data-tid": "MenuItem__comment",
        className: cx((_cx2 = {}, _cx2[styles.comment(_this.theme)] = true, _cx2[styles.commentHover(_this.theme)] = hover, _cx2))
      }, comment));
    };

    _this.handleMouseEnterFix = function (e) {
      if (!_this.mouseEntered && _this.props.onMouseEnter) {
        _this.mouseEntered = true;

        _this.props.onMouseEnter(e);
      }
    };

    _this.handleMouseLeave = function (e) {
      _this.mouseEntered = false;

      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(e);
      }
    };

    _this.getComponent = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          component = _this$props.component,
          href = _this$props.href;

      if (disabled) {
        return 'button';
      }

      if (component) {
        return component;
      }

      if (href) {
        return 'a';
      }

      return 'button';
    };

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  };

  return MenuItem;
}(React.Component);
MenuItem.__KONTUR_REACT_UI__ = 'MenuItem';
MenuItem.__MENU_ITEM__ = true;
MenuItem.propTypes = {
  comment: PropTypes.node,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loose: PropTypes.bool,
  state: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func
};
export var isMenuItem = function isMenuItem(child) {
  return /*#__PURE__*/React.isValidElement(child) ? Object.prototype.hasOwnProperty.call(child.type, '__MENU_ITEM__') : false;
};